module.exports = "https://web-assets.ifttt.com/packs/media/energy_challenge/logo-homeconnect-3b04fea4.png";